// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8effb532","674":"a512e68c"}[chunkId] + ".chunk.js";
};